<div style="position:relative; z-index: 100; width: 100%;">
<nav class="navbar navbar-expand-md pt-0 " style="position: fixed; width: 100%;">
  <div class="container">
    <a class="navbar-brand" [routerLink]="['']"><img class="lozad" src="assets/img/rev00.png"> </a>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse ms-md-4" id="navbarNav">
      <ul class="navbar-nav">
        <li class="nav-item">
          <a class="nav-link" aria-current="page" [routerLink]="['']">Home</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [routerLink]="['/about']">About Us</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [routerLink]="['/network']">Network</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [routerLink]="['/digital']">Digital Tribe</a>
        </li>
      </ul>
    </div>
  </div>
</nav>
</div>

<section>
	<div class="hero  position-relative overflow-hidden">
		<div class="welcome" >
			<h1 data-aos="fade-up" class="d-flex align-items-center gap-3 justify-content-center">
			The Voice of Change is Here</h1>
		</div>
			<div class="shad position-absolute"></div>
			<div class="blur">
				<svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 1024 1024"><path fill="#fff" d="M848 359.3H627.7L825.8 109c4.1-5.3.4-13-6.3-13H436c-2.8 0-5.5 1.5-6.9 4L170 547.5c-3.1 5.3.7 12 6.9 12h174.4l-89.4 357.6c-1.9 7.8 7.5 13.3 13.3 7.7L853.5 373c5.2-4.9 1.7-13.7-5.5-13.7" stroke-width="25.5" stroke="#fff"/></svg>
			</div>
	</div>
</section>
<!---END HERO SECTION---->

<!---- BUSINESS OWNER SECTION--->

<section>
	<div class="owner my-5 bg-transparent">
		<div class="container">
			<div class="row justify-content-center">
				<div class="col-md-9">
					<div class="business">
					<h2 class="our text-center" data-aos="fade-up ">Weekly Scholarships to HBCUs</h2>
					<p data-aos="fade-up">We invest in our future leaders. Every week, Revolution awards scholarships to students attending <b>Historically Black Colleges and Universities.</b> Your membership helps uplift the next generation of Black excellence.</p>
					
			      </div>
				</div>
			</div>
		</div>
	</div>
</section>
<!----END BUSINESS OWNER SECTION--->


<!---- CARDS SECTION--->
<section>
	<div class="packages pt-0">
		<div class="container">
			<div class="row justify-content-center">
				<div class="col-md-10">
					<h2 class="join " data-aos="fade-up"> Creative Contests & Exciting Prizes</h2>
			<p class="join mb-5" data-aos="fade-up">Unleash your talent through <b>weekly contests</b> in art, music, dance, and more. Winners receive amazing prizes and gain recognition across the platform. Let your creativity spark change.</p>
				</div>
			</div>
			<div class="row ">
				<div class="col-lg-6 col-md-9 mb-3 mb-lg-0 px-4">
					<div class="membership-cards" data-aos="fade-right">
						<div class="card networkcard border-white gift" >
						<h2>Weekly Vouchers & Gift</h2>
						<!-- <b>Start building your digital neighborhood.</b> -->
						<p>Support Black-owned businesses with our weekly giveaways:</p>
						<!-- <h1 class="card-title"> $5.99/<span>month</span></h1> -->
						<ul class="ps-3">
							<li class="fw-bold">$250 and $500 gift cards</li>
							<li>Usable at participating Black-owned shops nationwide</li>
							<li>Encouraging us to buy Black and build Black</li>
						</ul>						
					</div>
					</div>
				</div>
				<div class="col-lg-6 col-md-9 mb-3 mb-lg-0 px-4">
					<div class="membership-cards" data-aos="fade-left">
						<div class="card networkcard border-white gift" >
						<h2> Monthly Cash Contests</h2>
						<b>Big money. Big motivation.</b>
						<p> Every month, compete for a chance to win:</p>
						<!-- <h1 class="card-title"> $49.99/<span>month</span></h1> -->
						<ul class="ps-3">
							<li class="fw-bold">$5,000 and $10,000 cash prizes</li>
							<li>Build, create, and rise through community-driven challenges</li>
						</ul>	
					</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
<!----END CARDS SECTION--->

<!----GIFT SECTION--->
<section id="knowledge" class="overflow-hidden">
	<div class="container my-5">
		<div class="row">
				<div class="col-md-6">
				<div class="organ-img stand  aos-init aos-animate" data-aos="zoom-in-down" >
					<img class="img-fluid lozad w-100" src="assets/img/Website_Images/education.png" style="height: 100%;border-radius: 20px;" alt="Image">
				</div>					
				</div>
				
				<div class="col-md-6">
					<div class="membership-cards" data-aos="fade-up">
						<div class="organization card mt-5 pt-5">
						<h2 class="purple ">Knowledge is Power</h2>
						<p  >Our platform is a space for knowledge-sharing and practical education:</p>
						<ul class="mt-3 ps-3">
							<li>Growing your own crops</li>
							<li>Building sustainable homes</li>
							<li>Buying land and developing neighborhoods</li>
							<li>Trading skills, ideas, and resources</li>
						</ul>
						<strong  class="mb-4 d-block ">Empower. Engage. Elevate.</strong>
						<a href="https://forms.gle/PFoTcEzW38zXaFKP8" target="_Blank" class="btn btn-hover-purple border-dark gap-2 mt-4 aos-init" >
						Join Now
					</a>
					</div>
					</div>
				</div>
			</div>
	</div>
</section>
<!----END GIFT SECTION--->

<!----PRIVACY,CONTROL SECTION--->
<section>
	<div class="privacy">
		<div class="container">
			<div class="row justify-content-center">
				<div class="col-lg-6 col-md-9">
					<div class="row">
						<div class="col-4">
							<div class="card border-transparent" data-aos="zoom-in">
							<svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 48 48"><path fill="#212529" d="M24 4c-5.5 0-10 4.5-10 10v4h4v-4c0-3.3 2.7-6 6-6s6 2.7 6 6v4h4v-4c0-5.5-4.5-10-10-10"/><path fill="#212529" d="M36 44H12c-2.2 0-4-1.8-4-4V22c0-2.2 1.8-4 4-4h24c2.2 0 4 1.8 4 4v18c0 2.2-1.8 4-4 4"/><circle cx="24" cy="31" r="6" fill="#212529"/><circle cx="24" cy="31" r="3" fill="#212529"/><circle cx="26" cy="29" r="1" fill="#212529"/></svg>
							<h3 class="text-white">Privacy</h3>
						</div>
						</div>
						<div class="col-4">
							<div class="card border-transparent" data-aos="zoom-in">
							<svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 32 32"><g fill="#212529"><path d="M28.354 1.354a.5.5 0 0 0-.141-.805a5.98 5.98 0 0 0-6.798 1.191c-1.698 1.709-2.291 4.393-1.499 6.637L8.377 19.916a5.9 5.9 0 0 0-1.996-.336c-1.714 0-3.376.682-4.559 1.872a6.08 6.08 0 0 0-1.281 6.747a.498.498 0 0 0 .813.153l3.491-3.509c.23-.232.601-.263.793-.068l1.507 1.577c.219.221.209.562-.022.795l-3.478 3.5a.5.5 0 0 0 .141.804a6 6 0 0 0 2.591.588c1.572 0 3.065-.632 4.207-1.78c1.698-1.708 2.291-4.392 1.498-6.636l11.539-11.54a5.9 5.9 0 0 0 1.997.336c1.714 0 3.376-.682 4.559-1.872A6.08 6.08 0 0 0 31.458 3.8a.498.498 0 0 0-.813-.153l-3.491 3.509a.57.57 0 0 1-.801-.01l-1.499-1.499a.55.55 0 0 1-.001-.794zm-4.208 5l1.499 1.499c.599.602 1.625.605 2.218.009l2.93-2.944a5.09 5.09 0 0 1-1.324 4.926c-.997 1.003-2.399 1.577-3.85 1.577c-.683 0-1.33-.128-1.923-.38a.5.5 0 0 0-.549.106l-12 12a.5.5 0 0 0-.107.547c.803 1.91.314 4.375-1.163 5.861a4.96 4.96 0 0 1-4.985 1.258l2.941-2.96c.621-.625.631-1.594.029-2.198l-1.506-1.577c-.581-.585-1.614-.549-2.218.062l-2.93 2.944a5.09 5.09 0 0 1 1.324-4.926c.997-1.003 2.399-1.577 3.85-1.577c.683 0 1.33.128 1.923.38a.5.5 0 0 0 .549-.106l12-12a.5.5 0 0 0 .107-.547c-.803-1.91-.314-4.376 1.163-5.862a4.96 4.96 0 0 1 4.982-1.258l-2.96 2.961a1.546 1.546 0 0 0 0 2.205"/></g></svg>
							<h3 class="text-white">Control</h3>

						</div>
						</div>
						<div class="col-4">
							<div class="card border-transparent" data-aos="zoom-in">
						 <!-- <svg width="64" height="64" viewBox="0 0 64 64" fill="white" xmlns="http://www.w3.org/2000/svg">
						  <text x="0" y="50" font-size="50" fill="white">🎉</text>
						</svg> -->

						  <svg xmlns="http://www.w3.org/2000/svg"  fill="#212529" viewBox="0 0 24 24">
							  <path d="M20 7h-2.18A3 3 0 0 0 15 2a3 3 0 0 0-2.83 2H11.83A3 3 0 0 0 9 2a3 3 0 0 0-2.82 3H4a1 1 0 0 0 0 2h1v11a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V9h1a1 1 0 0 0 0-2zm-5-3a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-6 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM8 20a1 1 0 0 1-1-1v-5h6v6H8zm8-1a1 1 0 0 1-1 1h-1v-6h6v5a1 1 0 0 1-1 1zM8 8v4H6V8h2zm10 4h-2V8h2v4z"/>
							

							</svg>
              <h3 class="text-white">Reward</h3>
						  </div>
						</div>
					</div>
				</div>
				<div class="col-md-10  mt-5">
					<div class="powered">
						<h3 data-aos="fade-up">Welcome to the Future of Community—powered by UMYO Wall Street Of Technology.</h3>
						<p data-aos="fade-up">With all of these features integrated into one platform, <b>REVOLUTION 00 </b>provides a comprehensive ecosystem that supports members in their personal and professional endeavors, whether they are entrepreneurs, creators, educators, or consumers. It offers tools for networking, monetization, privacy, content creation, mental health support, and more.</p>
						<a class="btn btn-hover-blue"  data-aos="fade-up">Read More</a>

						<h2 class="mt-5" data-aos="fade-up">Private, Gated Communities</h2>
						<p class="text-start mt-4" data-aos="fade-up"><strong>Choose from over 10 private groups that are:</strong></p>
				    <ul class="member-actions ps-0" data-aos="fade-up">
				      <li>Secure and monitored for positivity and safety</li>
				      <li>Equipped with features like video conferencing</li>
				      <li>Perfect for authentic conversations and virtual meetups</li>
				    </ul>
						
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
<!----END PRIVACY,CONTROL SECTION--->



<!----READ MORE SECTION--->

<section id="detailsSection" class="overflow-hidden">
	<div class="container">
		 <div class="row justify-content-center">
		 	<div class="col-lg-9">
		 		<h2 class="text-center text-white">Explore Our Private Digital Communities</h2>
				  <p class="text-center text-white">Revolution-00 offers multiple exclusive, gated platforms — each designed to empower, educate, and connect organizations, creators, entrepreneurs, families, and visionaries.</p>
		 	</div>
		 </div>
		 <div class="row">
		 	<div class="col-md-4 p-3 " data-aos="fade-up">
		 		<div class="platform p-3">
		 			<img class="img-fluid lozad" src="assets/img/Strolling_Images/r00_talks.png" alt="Image">
		 			<h3>Revolution-00 Talk </h3>
		 			
		 			<div class="description mt-3" style="display: none" id="talk">
		 				<span> Buy, Sell, Connect — All in One Place.</span>
 						<p> Revolution-00 Talk is your community marketplace built for trust and connection. List your products, promote your services, and discover amazing offers — all within a secure, member-only ecosystem. Whether you're buying, selling, or networking, Revolution-00 Talk makes it easy to keep business circulating within the community.</p>
 						<ul>
 							<li>Post Items for Sale</li>
 							<li>Offer Services</li>
 							<li> Support Local Entrepreneurs</li>
 							<li> Build Community Wealth</li>
 						</ul>
 						<span>Ready to make moves?</span>
 						<p> Explore Revolution-00 Talk today.</p>
 						<a href="javascript:void(0)"  id="talk_less_btn" class="btn btn-hover-purple border-dark  gap-2 mt-2" >
						Read Less
					</a>
		 			</div>
		 			<a onclick="sectionShow('talk')"  id="talk_more_btn" class="btn btn-hover-purple border-dark  gap-2 mt-2 aos-init aos-animate" >
						Read More
					</a>		 			
		 		</div>
		 	</div>
		 	<div class="col-md-4 p-3 " data-aos="fade-up">
		 		<div class="platform p-3">
		 			<img class="img-fluid lozad" src="assets/img/Strolling_Images/r00_tweets.png" alt="Image">
		 			<h3>Revolution-00 Tweets</h3>
		 			
		 			<div class="description mt-3" style="display: none" id="tweet">
		 				<span>Speak Your Mind. Inspire Your Tribe.</span>
 						<p>Revolution-00 Tweets give you a voice inside a thriving, positive space. Share quick thoughts, breaking news, motivational quotes, or start impactful conversations. Here, every message moves the culture forward — without the noise or negativity.</p>
 						<ul>
 							<li>Instant Micro-Posts</li>
 							<li>Trending Conversations</li>
 							<li>Follow Like-Minded Voices</li>
 							<li>Elevate Community Dialogue</li>
 						</ul>
 						<span>Your voice matters.
           </span>
           <p>Start tweeting with purpose on Revolution-00 Tweets.</p>
 						<a href="javascript:void(0)"  id="tweet_less_btn" class="btn btn-hover-purple border-dark  gap-2 mt-2" >
						Read Less
					</a>
		 			</div>
		 			<a  onclick="sectionShow('tweet')"  id="tweet_more_btn" class="btn btn-hover-purple border-dark  gap-2 mt-2 aos-init aos-animate" >
						Read More
					</a>		 			
		 		</div>
		 	</div>
		 	<div class="col-md-4 p-3 " data-aos="fade-up">
		 		<div class="platform p-3">
		 			<img class="img-fluid lozad" src="assets/img/Strolling_Images/r00_events.png" alt="Image">
		 			<h3>R00 Events</h3>
		 			
		 			<div class="description mt-3" style="display: none" id="event">
		 				<span> Host. Attend. Celebrate.</span>
 						<p>R00 Events are where connections turn into experiences. From business conferences and virtual workshops to pop-up shops and festivals, easily create, promote, and attend events that keep the community thriving. Find your next opportunity — or create one!</p>
 						<ul>
 							<li> Create and Manage Events</li>
 							<li>Sell Tickets Online</li>
 							<li>Promote Gatherings and Meetups</li>
 							<li>Discover Community Events Near You</li>
 						</ul>
 						<span>Your next big event starts here.</span>
            <p>Find or host an experience with UMYO Events.</p>
 						<a href="javascript:void(0)"  id="event_less_btn" class="btn btn-hover-purple border-dark  gap-2 mt-2 aos-init aos-animate " >
						Read Less
					</a>
		 			</div>
		 			<a  onclick="sectionShow('event')"  id="event_more_btn" class="btn btn-hover-purple border-dark  gap-2 mt-2 aos-init aos-animate" >
						Read More
					</a>		 			
		 		</div>
		 	</div>
		 </div>

		 <div class="row">
		 	<div class="col-md-4 p-3 " data-aos="fade-up">
		 		<div class="platform p-3">
		 			<img class="img-fluid lozad" src="assets/img/Strolling_Images/r00_radio.png" alt="">
		 			<h3>R00 Radio</h3>
		 			
		 			<div class="description mt-3" style="display: none" id="radio">
		 				<span>Tune in and level up.</span>
 						<p>Access live radio shows and online educational tools to continue your personal and professional growth. Stay connected to empowerment resources, community stories, and enriching learning materials. Plus, you can become your own DJ and play some of the top songs with licensing rights, giving you the freedom to curate your own musical experience for your audience.</p>
 						<ul>
 							<li>Live Radio Shows for Community Empowerment</li>
 							<li>Educational Resources to Elevate Your Knowledge</li>
 							<li>Connect with Experts and Like-Minded Learners</li>
 							<li>Real-Time Updates for Continuous Growth</li>
 							<li>Become Your Own DJ: Play top songs with licensing rights, adding a musical touch to your broadcasts.</li>
 						</ul>
 						<span>Stay connected, stay empowered, and level up with R00</span>
 						<a href="javascript:void(0)"  id="radio_less_btn" class="btn btn-hover-purple border-dark  gap-2 mt-2" >
						Read Less
					</a>
		 			</div>
		 			<a  onclick="sectionShow('radio')"  id="radio_more_btn" class="btn btn-hover-purple border-dark  gap-2 mt-2" >
						Read More
					</a>		 			
		 		</div>
		 	</div>
		 	<div class="col-md-4 p-3 " data-aos="fade-up">
		 		<div class="platform p-3">
		 			<img class="img-fluid lozad" src="assets/img/Strolling_Images/r00_appointments.png" alt="">
		 			<h3 class="text-nowrap">Revolution-00 Appointments</h3>
		 			
		 			<div class="description mt-3" style="display: none" id="appoint">
		 				<span>Manage Your Business. Build Your Brand.</span>
 						<p> R00 Appointments is your all-in-one scheduling powerhouse designed for entrepreneurs, beauty professionals, consultants, and service providers. Seamlessly manage appointments, reduce no-shows, and optimize your calendar — all while building a custom professional website to showcase your services.</p>
 						<ul>
 							<li>Easy Online Appointment Booking</li>
 							<li>Automated Reminders and Confirmations</li>
 							<li>Calendar Management Made Simple</li>
 							<li>Create Your Own Branded Website</li>
 							<li>Showcase Services, Take Payments, and Grow Online</li>
 						</ul>
 						<span>Control your schedule. Control your brand.</span>
            <p>Launch your business to new heights with R00 Appointments.</p>
 						<a href="javascript:void(0)"  id="appoint_less_btn" class="btn btn-hover-purple border-dark  gap-2 mt-2 " >
						Read Less
					</a>
		 			</div>
		 			<a  onclick="sectionShow('appoint')"  id="appoint_more_btn" class="btn btn-hover-purple border-dark  gap-2 mt-2 " >
						Read More
					</a>		 			
		 		</div>
		 	</div>
		 	<div class="col-md-4 p-3 " data-aos="fade-up">
		 		<div class="platform p-3">
		 			<img class="img-fluid lozad" src="assets/img/Strolling_Images/r00_music.png" alt="">
		 			<h3>R00 Music</h3>
		 			
		 			<div class="description" style="display: none;" id="music">
		 				<span>Stream. Share. Monetize.</span>
		 				<p>UMYO Music is a powerful music streaming service where artists can upload, share, and discover music. Whether you’re a creator looking to share your latest track or a listener exploring new sounds, UMYO Music lets you enjoy and monetize your music through ads or premium subscriptions, making it easy for you to grow your audience.</p>
 						<ul>
 							<li>Upload, Share, and Stream Your Music</li>
 							<li>Monetize Tracks Through Ads and Subscriptions</li>
 							<li>Discover New Music from Emerging Artists</li>
 							<li>Create Playlists, Share with Friends, and Build Your Fanbase</li>
 						</ul>
 						<span>Your music. Your audience. Your stage.</span>
 						<a href="javascript:void(0)"  id="music_less_btn" class="btn btn-hover-purple border-dark  gap-2 mt-2 aos-init aos-animate " >
					  Read Less
					</a>
		 			</div>
		 			<a  id="music_more_btn" onclick="sectionShow('music')" class="btn btn-hover-purple border-dark  gap-2 mt-2 aos-init aos-animate" >
						Read More
					</a>		 			
		 		</div>
		 	</div>
		 </div>

		 <div class="row">
		 	<div class="col-md-4 p-3 " data-aos="fade-up">
		 		<div class="platform p-3">
		 			<img class="img-fluid lozad" src="assets/img/Strolling_Images/r00_livestream.png" alt="">
		 			<h3>R00 Livestream</h3>
		 			
		 			<div class="description" style="display: none;" id="stream">
		 				<span>Broadcast your voice to thousands.</span>
						<p>Host live podcasts and share important topics with a global audience. Whether you're discussing personal growth, industry insights, or community empowerment, UMYO's Live Podcast Platform lets you reach and engage listeners like never before. Grow your personal brand, monetize through sponsorships, and create lasting connections.</p>
 						<ul>
 							<li>Host Live Podcasts on Any Topic</li>
 							<li>Grow Your Personal Brand and Earn Through Sponsorships</li>
 							<li>Stream with Audio and Video</li>
 							<li>Interactive: Engage with Your Listeners in Real-Time</li>
 							<li>Audio-Only Stream Option for Focused Conversations</li>
 						</ul>
 						<span>Your voice, your audience, your platform.</span>
              <a href="javascript:void(0)"  id="stream_less_btn" class="btn btn-hover-purple border-dark  gap-2 mt-2 aos-init aos-animate " >
						Read Less
					</a>

		 			</div>
		 			<a  id="stream_more_btn" onclick="sectionShow('stream')" class="btn btn-hover-purple border-dark  gap-2 mt-2 aos-init aos-animate" >
						Read More
					</a>		 			
		 		</div>
		 	</div>
		 	<div class="col-md-4 p-3 " data-aos="fade-up">
		 		<div class="platform p-3">
		 			<img class="img-fluid lozad" src="assets/img/Strolling_Images/r00_thinktribe.png" alt="">
		 			<h3>R00 Think Tribe- LMS</h3>
		 			
		 			<div class="description" style="display: none;" id="think">
		 				<span>Empower Minds. Elevate Futures.</span>
            <p>Roo Learning is a full-featured Learning Management System (LMS) designed to manage, deliver, and track educational courses and training programs. Whether you're an educator, a trainer, or a lifelong learner, R00 Learning serves as your central hub to create, share, and engage with powerful educational experiences.</p>
 						<ul>
 							<li>Build and Host Interactive Courses</li>
 							<li>Deliver Certifications, Workshops, and Trainings</li>
 							<li>Track Learner Progress with Powerful Analytics</li>
 							<li> Create Video Lessons, Quizzes, and Discussion Boards</li>
 							<li> Engage Students Anytime, Anywhere — Mobile Friendly</li>
 						</ul>
 						<span>Teach boldly. Learn fearlessly. Grow together.
             Unlock your knowledge potential with ROO Learning.</span>
             <a href="javascript:void(0)"  id="think_less_btn" class="btn btn-hover-purple border-dark  gap-2 mt-2 aos-init aos-animate " >
						Read Less
					</a>
		 			</div>
		 			<a  id="think_more_btn" onclick="sectionShow('think')" class="btn btn-hover-purple border-dark  gap-2 mt-2 aos-init aos-animate" >
						Read More
					</a>		 			
		 		</div>
		 	</div>
		 	<div class="col-md-4 p-3 " data-aos="fade-up">
		 		<div class="platform p-3">
		 			<img class="img-fluid lozad" src="assets/img/Strolling_Images/r00_dating.png" alt="">
		 			<h3> R00 Dating</h3>
		 			
		 			<div class="description" style="display: none;" id="dating">
		 				<span>Find Connection. Build Community.</span>
		 				<p> R00 Dating is an exclusive matchmaking platform designed for members of your organization, union, or community. Connect with like-minded individuals who share your values, passions, and lifestyle — all within a secure and respectful environment. Whether you're looking for friendship, love, or partnership, R00 Dating helps you build meaningful connections that last</p>
 						<ul>
 							<li>Swipe, Match, and Chat with Verified Members</li>
 							<li>Built Around Shared Interests and Community Values</li>
 							<li>Safe, Private, and Moderated for a Respectful Experience</li>
 							<li> Create a Profile that Reflects Who You Truly Are</li>
 						</ul>
 						<span>Love where you come from.</span>
 						<span> Love who you meet.</span>
 						<span>Love who you meet.<br>Discover authentic connections with R00 Dating.</span>
 						<a href="javascript:void(0)"  id="dating_less_btn" class="btn btn-hover-purple border-dark  gap-2 mt-2 aos-init aos-animate " >
						Read Less
					</a>
		 			</div>
		 			<a  id="dating_more_btn" onclick="sectionShow('dating')"  class="btn btn-hover-purple border-dark  gap-2 mt-2 aos-init aos-animate" >
						Read More
					</a>		 			
		 		</div>
		 	</div>
		 </div>

		 	<div class="row">
		 	<div class="col-md-4 p-3 " data-aos="fade-up">
		 		<div class="platform p-3">
		 			<img class="img-fluid lozad" src="assets/img/Strolling_Images/r00_fans.png" alt="">
		 			<h3>R00 Fans</h3>
		 			
		 			<div class="description" style="display: none;" id="fans">
		 				<span>Create. Connect. Monetize.</span>
		 				<p>R00 Fans is an exclusive content-sharing platform that allows creators to earn money by sharing premium content with their fans. Whether you’re an artist, influencer, or content creator, R00 Fans helps you monetize your work through subscriptions, exclusive content, and direct fan interactions.</p>
 						<ul>
 							<li> Monetize Content Through Subscriptions</li>
 							<li> Create Exclusive Content for Your Fans</li>
 							<li> Connect with Fans on a Deeper, More Personal Level</li>
 							<li>Offer Behind-the-Scenes Access, Early Releases, and More</li>
 						</ul>
 						<span>Engage with your community and turn your passion into income.</span>

 						<a href="javascript:void(0)"  id="fans_less_btn" class="btn btn-hover-purple border-dark  gap-2 mt-2 aos-init aos-animate " >
						Read Less
					</a>
		 			</div>
		 			<a  id="fans_more_btn" onclick="sectionShow('fans')" class="btn btn-hover-purple border-dark  gap-2 mt-2 aos-init aos-animate" >
						Read More
					</a>		 			
		 		</div>
		 	</div>
		 	<div class="col-md-4 p-3 " data-aos="fade-up">
		 		<div class="platform p-3">
		 			<img class="img-fluid lozad" src="assets/img/Strolling_Images/r00_estore.png" alt="">
		 			<h3>R00 Estore</h3>
		 			
		 			<div class="description" style="display: none;" id="store">.
		 				<span>Sell. Promote. Prosper.</span>
		 				<p> R00 Pop-Up Shop is a fully integrated e-commerce platform that allows you to create and manage your online store with ease. Whether you’re selling physical products or digital goods, R00 Pop-Up Shop makes it simple to launch your brand and reach a global audience.</p>
 						<ul>
 							<li> Create Your Online Store in Minutes</li>
 							<li> Sell Digital and Physical Products</li>
 							<li> Promote Your Products and Track Sales</li>
 							<li>  Reach a Global Audience with Secure Payments</li>
 						</ul>
 						<span>Turn your passion into profits with R00 Pop-Up Shop.</span>
 						<a href="javascript:void(0)"  id="store_less_btn" class="btn btn-hover-purple border-dark  gap-2 mt-2 " >
						Read Less
					</a>
		 			</div>
		 			<a  id="store_more_btn" onclick="sectionShow('store')" class="btn btn-hover-purple border-dark  gap-2 mt-2 aos-init aos-animate" >
						Read More
					</a>		 			
		 		</div>
		 	</div>
		 	<div class="col-md-4 p-3 " data-aos="fade-up">
		 		<div class="platform p-3">
		 			<img class="img-fluid lozad" src="assets/img/Strolling_Images/r00_livestream.png" alt="">
		 			<h3>R00 Conferencing</h3>
		 			
		 			<div class="description" style="display: none;" id="conference">
		 				<p><strong>Broadcast your voice to thousands.</strong></p>
		 				<p>Host live podcasts and share important topics with a global audience. Whether you're discussing personal growth, industry insights, or community empowerment, UMYO's Live Podcast Platform lets you reach and engage listeners like never before. Grow your personal brand, monetize through sponsorships, and create lasting connections.</p>
 						<ul>
 							<li> Host Live Podcasts on Any Topic</li>
 							<li>Grow Your Personal Brand and Earn Through Sponsorships</li>
 							<li>Stream with Audio and Video</li>
 							<li> Interactive: Engage with Your Listeners in Real-Time</li>
 							<li>Audio-Only Stream Option for Focused Conversations</li>
 						</ul>
 						<span>Your voice, your audience, your platform.</span>
 						<a href="javascript:void(0)"  id="conference_less_btn" class="btn btn-hover-purple border-dark  gap-2 mt-2 aos-init aos-animate " >
						Read Less
					</a>
		 			</div>
		 			<a  id="conference_more_btn" onclick="sectionShow('conference')"  class="btn btn-hover-purple border-dark  gap-2 mt-2 aos-init aos-animate" >
						Read More
					</a>		 			
		 		</div>
		 	</div>
		 </div>

		 	<div class="row">
		 	<div class="col-md-4 p-3 " data-aos="fade-up">
		 		<div class="platform p-3">
		 			<img class="img-fluid lozad" src="assets/img/Strolling_Images/R00_Youth_Minded.png" alt="">
		 			<h3>R00 Youth</h3>
		 			
		 			<div class="description" style="display: none;" id="youth">
		 				<span>Buy. Sell. Connect. Grow.</span>
		 				<p>R00 Youth is a safe, engaging marketplace tailored specifically for younger generations. Whether you're looking to buy, sell, or trade items, R00 Youth provides a platform where young entrepreneurs, creators, and community members can connect, share, and grow together. It’s a vibrant, youth-focused space that empowers young people to engage in commerce and creativity while learning essential life skills.</p>
 						<ul>
 							<li>Buy and Sell Products in a Safe Environment</li>
 							<li>Create Listings for Clothes, Games, Art, and More</li>
 							<li>Connect with Like-Minded Young Entrepreneurs</li>
 							<li>Learn Valuable Skills like Sales, Marketing, and Negotiation</li>
 							<li>Exchange Ideas and Build Connections with Other Youth</li>
 						</ul>
 						<span>Empower your entrepreneurial spirit with R00 Youth.</span>
 						<a href="javascript:void(0)"  id="youth_less_btn" class="btn btn-hover-purple border-dark  gap-2 mt-2 aos-init aos-animate " >
						Read Less
					</a>
		 			</div>
		 			<a  id="youth_more_btn" onclick="sectionShow('youth')" class="btn btn-hover-purple border-dark gap-2 mt-2 aos-init aos-animate" >
						Read More
					</a>		 			
		 		</div>
		 	</div>
		 	<div class="col-md-4 p-3 " data-aos="fade-up">
		 		<div class="platform p-3">
		 			<img class="img-fluid lozad" src="assets/img/Strolling_Images/Prize_Giveaways.png" alt="">
		 			<h3>R00 Prize Giveaway</h3>
		 			
		 			<div class="description" style="display: none;" id="prize">
		 				<span>Boost Engagement and Grow Your Community</span>
		 				<p>Engage your community with regular online contests and giveaways designed to incentivize platform registration and boost participation. These exciting events drive traffic to your platform, increase membership, and provide a fun way to reward loyal users while growing your audience.</p>
 						<ul>
 							<li>Exciting Contests and Giveaways</li>
 							<li>Increase Platform Engagement</li>
 							<li>Reward Loyal Users and Drive Traffic</li>
 						</ul>
 						<a href="javascript:void(0)"  id="prize_less_btn" class="btn btn-hover-purple border-dark  gap-2 mt-2 aos-init aos-animate " >
						Read Less
					</a>
		 			</div>
		 			<a id="prize_more_btn" onclick="sectionShow('prize')" class="btn btn-hover-purple border-dark  gap-2 mt-2 " >
						Read More
					</a>		 			
		 		</div>
		 	</div>
		 	<div class="col-md-4 p-3 " data-aos="fade-up">
		 		<div class="platform p-3">
		 			<img class="img-fluid lozad" src="assets/img/Strolling_Images/Coupon_Booklet.png" alt="">
		 			<h3>R00 Coupon Booklet</h3>
		 			
		 			<div class="description mt-3" style="display: none" id="book">
		 				<span>Maximize Your Reach.</span>
 						<p>Our targeted advertising platform allows businesses of all types to advertise directly to their specific audience—those most interested in your products or services. This powerful platform ensures your ads reach the right people, leading to higher conversion rates and more successful campaigns.</p>
 						<ul>
 							<li>Reach a Highly Relevant Audience</li>
 							<li>Increase Conversion Rates</li>
 							<li>Improve Brand Visibility</li>
 						</ul>
 						<a href="javascript:void(0)"  id="book_less_btn" class="btn btn-hover-purple border-dark  gap-2 mt-2 aos-init aos-animate " >
						Read Less
					</a>
		 			</div>
		 			<a  onclick="sectionShow('book')"  id="book_more_btn" class="btn btn-hover-purple border-dark  gap-2 mt-2 aos-init aos-animate" >
						Read More
					</a>		 			
		 		</div>
		 	</div>
		 </div>

		 	<div class="row">
		 	<div class="col-md-4 p-3 " data-aos="fade-up">
		 		<div class="platform p-3">
		 			<img class="img-fluid lozad" src="assets/img/Strolling_Images/video_magazine.png" alt="">
		 			<h3> R00 Video Magazine</h3>
		 			
		 			<div class="description mt-3" style="display: none" id="magazine">
		 				<span>Digital Video Magazine</span>
 						<p>Tailored Content for Your Industry. R00’s Digital Video Magazine is the perfect platform for industries like unions, organizations, and others to create and share industry-specific content. Publish and distribute video content that highlights your expertise, community, and industry trends to a dedicated audience.</p>
 						<ul>
 							<li>Share Industry Insights and Updates</li>
 							<li>Engage with Your Target Audience</li>
 							<li>Create a Stronger Online Presence</li>
 						</ul>
 						<span>Stay connected, stay empowered, and level up with UMYO.</span>
 						<a href="javascript:void(0)"  id="magazine_less_btn" class="btn btn-hover-purple border-dark  gap-2 mt-2 aos-init aos-animate " >
						Read Less
					</a>
		 			</div>
		 			<a  onclick="sectionShow('magazine')"  id="magazine_more_btn" class="btn btn-hover-purple border-dark  gap-2 mt-2 aos-init aos-animate" >
						Read More
					</a>		 			
		 		</div>
		 	</div>
		 	<div class="col-md-4 p-3 " data-aos="fade-up">
		 		<div class="platform p-3">
		 			<img class="img-fluid lozad" src="assets/img/Strolling_Images/R00_news.png" alt="">
		 			<h3>R00 News</h3>
		 			
		 			<div class="description" style="display: none;" id="news">
		 				<span>Your Automated News Hub. Best of Sports & Entertainment.</span>
		 				<p><strong>R00 News</strong> is an innovative news and automated magazine platform designed to keep you informed on the latest in sports, entertainment, and more as it relates to people of color. With real-time updates, personalized content, and easy-to-navigate sections, R00 News delivers the best headlines directly to you.</p>
 						<ul>
 							<li>Automated News Updates</li>
 							<li>Sports, Entertainment, and Lifestyle Coverage</li>
 							<li>Curated Content for Your Interests</li>
 							<li> Get the Latest Headlines in Real-Time</li>
 							<li> Seamlessly Navigate Through Categories</li>
 							<li>Discover Trending Stories</li>
 							<li> Share and Discuss with Community Members</li>
 						</ul>
 						<span>Stay Informed. Stay Ahead.</span>
 						<p> Whether you’re a sports fanatic, an entertainment enthusiast, or simply want to stay updated on the latest news, <b>R00 News</b> offers a curated, dynamic experience. From breaking news to trending stories, UMYO News brings everything you need to know straight to your screen.</p>
 						<a href="javascript:void(0)"  id="news_less_btn" class="btn btn-hover-purple border-dark  gap-2 mt-2 aos-init aos-animate " >
						Read Less
					</a>
		 			</div>
		 			<a  id="news_more_btn" onclick="sectionShow('news')"  class="btn btn-hover-purple border-dark  gap-2 mt-2 aos-init aos-animate" >
						Read More
					</a>		 			
		 		</div>
		 	</div>
		 	<div class="col-md-4 p-3 " data-aos="fade-up">
		 		<div class="platform p-3">
		 			<img class="img-fluid lozad" src="assets/img/Strolling_Images/Talent_Video.png" alt="">
		 			<h3>R00 Video</h3>
		 			
		 			<div class="description" style="display: none;" id="talent">
		 				<span>Your Voice. Your Platform. Your Digital Stage.</span>
		 				<p>UMYOVideo is the all-in-one video platform built for unions, organizations, creators, and community leaders who want to share, teach, entertain, and inspire—on their own terms. More than just a place to post videos, UMYOVideo is a safe, purpose-driven digital stage designed to elevate authentic voices and drive meaningful engagement.</p>
 						<ul>
 							<li>Upload & Share Videos with Ease</li>
 							<li>Ad-Free, Secure Viewing Experience</li>
 							<li>Community-Centered Channels & Categories</li>
 							<li>Comments & Live Chat Options for Real Engagement</li>
 							<li>Real-Time Analytics & Creator Dashboards</li>
 							<li>Monetization Tools for Members & Organizations</li>
 							<li>Content Moderation to Promote Respectful Dialogue</li>
 							<li>Collaboration Spaces for Team Projects & Series </li>
 						</ul>
 						<span>SStream with Purpose. Connect with Power.</span>
 						<p>Whether you're hosting community meetings, showcasing talent, or building your digital media brand, UMYOVideo.com gives you the tools to broadcast your message without boundaries. Your content. Your control. Your community.</p>
 						<a href="javascript:void(0)"  id="talent_less_btn" class="btn btn-hover-purple border-dark  gap-2 mt-2 aos-init aos-animate " >
						Read Less
					</a>
		 			</div>
		 			<a  id="talent_more_btn" onclick="sectionShow('talent')" class="btn btn-hover-purple border-dark  gap-2 mt-2 aos-init aos-animate" >
						Read More
					</a>		 			
		 		</div>
		 	</div>

		 	<div class="col-md-4 p-3 " data-aos="fade-up">
		 		<div class="platform p-3">
		 			<img class="img-fluid lozad" src="assets/img/Strolling_Images/r00_games.png" alt="">
		 			<h3>Roo’s Games</h3>
		 			
		 			<div class="description" style="display: none;" id="game">
		 				<span>Play, Compete, and Engage.</span>
		 				<p>ROO Games is a mobile gaming app available for both Android and Apple devices. It offers a variety of casual and puzzle games designed to entertain and engage users, providing a fun and rewarding experience for players of all skill levels. Challenge yourself and others in exciting games while earning rewards.</p>
 						<ul>
 							<li>Mobile Gaming on-the-Go</li>
 							<li>Casual and Puzzle Games</li>
 							<li>Earn Rewards as You Play</li>
 						</ul>
 						<a href="javascript:void(0)"  id="game_less_btn" class="btn btn-hover-purple border-dark  gap-2 mt-2 " >
						Read Less
					</a>
		 			</div>
		 			<a  id="game_more_btn" onclick="sectionShow('game')" class="btn btn-hover-purple border-dark  gap-2 mt-2 " >
						Read More
					</a>		 			
		 		</div>
		 	</div>

		 	<div class="col-md-4 p-3 " data-aos="fade-up">
		 		<div class="platform p-3">
		 			<img class="img-fluid lozad" src="assets/img/Strolling_Images/r00_vpn.png" alt="">
		 			<h3>Roo’s VPN</h3>
		 			
		 			<div class="description" style="display: none;" id="vpn">
		 				<span>Protect Your Privacy. Empower Your Freedom. </span>
		 				<p>R00’s VPN provides top-tier, military-grade encryption to keep your online activity private and secure. Whether you're connecting on public Wi-Fi, browsing sensitive information, or simply safeguarding your personal data, R00 VPN ensures that your digital life remains yours alone.</p>
 						<ul>
 							<li>Secure Your Internet Connection with One Click</li>
 							<li>Protect Personal Data and Identity</li>
 							<li>Access Content Safely Across the Globe</li>
 							<li>Fast, Reliable, and Private Servers</li>
 							<li>No Logs Policy — Your Information Stays Yours</li>
 						</ul>
 						<span>Stay unseen. Stay protected. Stay powerful. Browse freely and securely with R00 VPN.</span>
 						<button   id="vpn_less_btn" onclick="hide()" class="btn btn-hover-purple border-dark  gap-2 mt-2 aos-init aos-animate " >
						Read Less
					</button>
		 			</div>
		 			<a  id="vpn_more_btn" onclick="sectionShow('vpn')" class="btn btn-hover-purple border-dark  gap-2 mt-2" >
						Read More
					</a>		 			
		 		</div>
		 	</div>

		 	<div class="col-md-4 p-3 " data-aos="fade-up">
		 		<div class="platform p-3">
		 			<img class="img-fluid lozad" src="assets/img/Strolling_Images/Men_No_Pause.png" alt="">
		 			<h3>Men No Pause</h3>
		 			
		 			<div class="description" style="display: none;" id="men">
		 				<span>Men United: Share. Heal. Build.</span>
		 				<span>Wednesdays @ 7:30 PM | Live Virtual Room<br>
             <a href="https://live.umyoconvo.site/rooms/menunited/join">https://live.umyoconvo.site/rooms/menunited/join</a> </span>
		 				<p>A safe, powerful space for men of all ages to come together, reflect, and rise. Whether you’re 18 or 80, Men United is where real stories are told, hard lessons are shared, and purpose is reclaimed.</p>
 						<ul>
 							<li> For the Young: Learn from seasoned men who’ve walked the road before you. Get life advice, career guidance, and mentorship from Black and Brown men who’ve made it—and made mistakes.</li>
 							<li>For the Grown: Pass the torch. Share your wisdom, experiences, and support. Be part of the collective upliftment of our community.</li>
 							<li> For the Brotherhood: This is your tribe. We network. We collaborate. We rise—together.</li>
 						</ul>
 						<span>Weekly Format:</span>
 						<p>Create. Open the session with a powerful prompt or question—spark the conversation.</p>
 						<p>Engage. Authentic discussions, breakout circles, or 1:1 storytelling to share lived experiences.</p>
 						<p>Innovate. Leave with a tool, plan, or connection. Every week offers something actionable—whether it’s mental wellness tips, entrepreneurial resources, or support circles.</p>
 						<button onclick="hide1()"  id="men_less_btn" class="btn btn-hover-purple border-dark  gap-2 mt-2" >
						Read Less
					</button>
		 			</div>
		 			<a  id="men_more_btn" onclick="sectionShow('men')" class="btn btn-hover-purple border-dark  gap-2 mt-2" >
						Read More
					</a>		 			
		 		</div>
		 	</div>
		 </div>

	</div>
</section>